import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Talent Pipeline & Offer Management',
    title: 'Move every candidate from applied to hired',
    subtitle: 'A visual hiring pipeline, AI offer-probability scoring, offer letters, and onboarding plans \u2014 all in one place. Keep your whole team aligned on who is moving forward and why.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #2C3E6B 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Pipeline Management',
      title: 'Your entire hiring funnel at a glance',
      features: [
        { icon: '\ud83d\udccb', title: 'Visual Kanban Board', desc: 'Drag candidates across stages \u2014 Applied, Screened, Assessed, Interviewed, Offer, Hired \u2014 with a real-time, shared view for your whole team.' },
        { icon: '\ud83d\udcc8', title: 'Offer Probability', desc: 'AI predicts each candidate\u2019s likelihood to accept an offer based on screening, assessment, and interview signals \u2014 so you prioritize the right people.' },
        { icon: '\ud83d\udcdc', title: 'Offer Management', desc: 'Create, send, and track offers with CTC, currency, joining date, and notes. Mark offers as draft, sent, accepted, or rejected.' },
        { icon: '\ud83d\ude80', title: 'AI Onboarding Plans', desc: 'Generate a structured 30/60/90-day onboarding plan automatically once an offer is accepted, tailored to the role.' },
        { icon: '\ud83d\udd52', title: 'Stage History', desc: 'Every stage change is timestamped and logged, giving you a complete audit trail of how each candidate progressed.' },
        { icon: '\ud83d\udc65', title: 'Team Visibility', desc: 'Completion badges and status indicators keep recruiters, admins, and hiring managers on the same page \u2014 no more status emails.' },
      ],
      columns: 3,
    },
    {
      label: 'How It Works',
      title: 'From shortlist to signed offer',
      desc: 'As candidates clear each stage, the pipeline updates automatically. Recruiters move people forward, generate offers, and trigger onboarding \u2014 without leaving CHIRE.',
      bullets: [
        'Candidates enter the pipeline the moment they apply or are uploaded',
        'AI scores and ranks them so the strongest rise to the top',
        'Drag candidates through stages as assessments and interviews complete',
        'Review AI offer-probability before extending an offer',
        'Create and send an offer with CTC, joining date, and notes',
        'On acceptance, auto-generate a tailored onboarding plan',
      ],
      visual: '\ud83d\udccb',
      visualLabel: 'Hiring Pipeline Board',
    },
    {
      label: 'For Hiring Teams',
      title: 'Decisions backed by data, not gut feel',
      desc: 'Stop guessing who to prioritize. CHIRE surfaces the candidates most likely to succeed and accept \u2014 and keeps the whole hiring committee aligned.',
      bullets: [
        'Offer-probability scoring highlights your best bets',
        'Shared Kanban removes status-update meetings',
        'Pipeline history gives full accountability',
        'Onboarding plans get new hires productive faster',
        'Works hand-in-hand with screening, assessments, and interviews',
      ],
      visual: '\ud83c\udfaf',
      visualLabel: 'Offer Probability Insights',
    },
  ],
  testimonial: {
    quote: 'The pipeline plus offer-probability scoring changed how we prioritize. We focus on candidates who will actually say yes, and onboarding plans are generated for us. Hiring velocity is up 3x.',
    name: 'Daniel M.',
    role: 'Head of Talent, Northwind Labs',
  },
  cta: {
    title: 'Run your whole hiring funnel in CHIRE',
    desc: 'Visual pipeline, AI offer scoring, and automated onboarding. Get started with CHIRE.',
  },
};

export default function PipelineProductPage() { return <ProductPageTemplate data={DATA} />; }
